<template>
    <v-dialog v-model="dialog" width="1200" persistent>
      <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
        <!-- Title Bar -->
        <v-card-title style="background-color: #f7cd45 !important; display: flex; justify-content: space-between; align-items: center; color: black;">
          <div>
            <span class="font-weight-bold text-h6" style="font-family: Saira Condensed, sans-serif;">{{ title }}</span>
            <div class="text-caption" style="font-family: Saira Condensed, sans-serif;">{{ sub_title }}</div>
          </div>
          <v-btn flat icon color="primary" @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
  
        <v-divider></v-divider>

        <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
          <v-container fluid>
            <v-row justify="center" align="stretch" class="text-center">
              
              <v-col cols="6" sm="4" md="2" class="pa-2">
                <v-card class="pa-2 bg-grey-lighten-4 rounded-lg">
                  <v-icon color="deep-purple" size="20">mdi-slot-machine</v-icon>
                  <div class="text-caption mt-1">Slots</div>
                  <div class="text-body-2 font-weight-medium">{{ totalNumberOfSlots() }}</div>
                </v-card>
              </v-col>

              <v-col cols="6" sm="4" md="2" class="pa-2">
                <v-card class="pa-2 bg-grey-lighten-4 rounded-lg">
                  <v-icon color="deep-purple" size="20">mdi-account-multiple</v-icon>
                  <div class="text-caption mt-1">Entries</div>
                  <div class="text-body-2 font-weight-medium">{{ totalNumberOfEntries() }}</div>
                </v-card>
              </v-col>

              <v-col cols="6" sm="4" md="2" class="pa-2">
                <v-card class="pa-2 bg-grey-lighten-4 rounded-lg">
                  <v-icon color="green" size="20">mdi-cash</v-icon>
                  <div class="text-caption mt-1">Start Cost</div>
                  <div class="text-body-2 font-weight-medium">$ {{ details.bonusHuntId.infoStartCost }}</div>
                </v-card>
              </v-col>

              <v-col cols="6" sm="4" md="2" class="pa-2">
                <v-card class="pa-2 bg-grey-lighten-4 rounded-lg">
                  <v-icon color="amber" size="20">mdi-trophy</v-icon>
                  <div class="text-caption mt-1">Prize</div>
                  <div class="text-body-2 font-weight-medium">
                    {{
                      tab === 1
                        ? (details.prize || '-')
                        : tab === 2
                          ? (details.gthpPrize || '-')
                          : '-'
                    }}
                  </div>
                </v-card>
              </v-col>

              <!-- <v-col cols="6" sm="4" md="3" class="pa-2">
                <v-card class="pa-2 bg-grey-lighten-4 rounded-lg">
                  <v-icon color="blue" size="20">mdi-progress-clock</v-icon>
                  <div class="text-caption mt-1">Status</div>
                  <div class="text-body-2 font-weight-medium">
                    <span v-if="details.status === 'started'">{{ $t('Fields_Label.Guess_The_Balance.Status.Started') }}</span>
                    <span v-else-if="details.status === 'ongoing'">{{ $t('Fields_Label.Guess_The_Balance.Status.Ongoing') }}</span>
                    <span v-else-if="details.status === 'done'">{{ $t('Fields_Label.Guess_The_Balance.Status.Done') }}</span>
                  </div>
                </v-card>
              </v-col> -->

              <v-col cols="12" sm="6" md="3" class="pa-2">
                <v-card class="pa-2 bg-grey-lighten-4 rounded-lg">
                  <v-icon color="purple" size="20">mdi-calendar-clock</v-icon>
                  <div class="text-caption mt-1">Created At</div>
                  <div class="text-body-2 font-weight-medium">
                    {{ formatDate(details.createdAt) }}
                  </div>
                </v-card>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        
        <!-- Tabs -->
        <v-tabs v-model="tab" background-color="transparent" grow>
          <v-tab>View All Entries</v-tab>
          <v-tab>GTB Top Winners</v-tab>
          <v-tab>GTHP Top Winners</v-tab>
        </v-tabs>
  
        <v-divider></v-divider>
  
        <v-card-text style="overflow-y: auto; max-height: calc(100vh - 180px);">
          <v-window v-model="tab">

            <v-window-item :value="0">
              <v-card class="dt-container mt-4">
                <v-data-table
                  v-model:items-per-page="itemsPerPage"
                  v-model:page="currentPage"
                  :mobile="isMobileOrTablet()"
                  :disable-sort="false"
                  :headers="viewAllEntriesHeader"
                  :items="gtbEntries"
                  :loading="loading"
                  class="text-subtitle-1"
                  style="font-family: Saira Condensed, sans-serif;"
                >
                  <template v-slot:item.createdAt="{ item }">
                    {{ formatExactTime(item.createdAt) }}
                  </template>
  
                  <template v-slot:loading>
                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                  </template>
                </v-data-table>
              </v-card>
            </v-window-item>
            
            <v-window-item :value="1">
              <v-card class="dt-container mt-4">
                <v-data-table
                  v-model:items-per-page="itemsPerPage"
                  v-model:page="currentPage"
                  :mobile="isMobileOrTablet()"
                  :disable-sort="false"
                  :headers="top10WinnersHeaders"
                  :items="gtbTopWinners"
                  :loading="loading"
                  class="text-subtitle-1"
                  style="font-family: Saira Condensed, sans-serif;"
                >
                  <template v-slot:item.placement="{ item, index }">
                    <span v-if="getActualPlacement(index) === 1">
                      <v-icon color="yellow darken-2">mdi-trophy</v-icon>
                      <strong>{{ getPlacement(getActualPlacement(index)) }}</strong>
                    </span>
                    <!-- <span v-else-if="getActualPlacement(index) === 2">
                      <v-icon color="grey darken-1">mdi-trophy</v-icon>
                      <strong>{{ getPlacement(getActualPlacement(index)) }}</strong>
                    </span>
                    <span v-else-if="getActualPlacement(index) === 3">
                      <v-icon color="brown darken-2">mdi-trophy</v-icon>
                      <strong>{{ getPlacement(getActualPlacement(index)) }}</strong>
                    </span> -->
                    <!-- <span v-else>
                      {{ getPlacement(getActualPlacement(index)) }}
                    </span> -->
                  </template>
  
                  <template v-slot:item.createdAt="{ item }">
                    {{ formatExactTime(item.createdAt) }}
                  </template>
  
                  <template v-slot:loading>
                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                  </template>
                </v-data-table>
              </v-card>
            </v-window-item>

            <v-window-item :value="2">
              <v-card class="dt-container mt-4">
                <v-data-table
                  v-model:items-per-page="itemsPerPage"
                  v-model:page="currentPage"
                  :mobile="isMobileOrTablet()"
                  :disable-sort="false"
                  :headers="top10GTHPWinnersHeaders"
                  :items="gthpTopWinners"
                  :loading="loading"
                  class="text-subtitle-1"
                  style="font-family: Saira Condensed, sans-serif;"
                >
                  <template v-slot:item.placement="{ item, index }">
                    <span v-if="getActualPlacement(index) === 1">
                      <v-icon color="yellow darken-2">mdi-trophy</v-icon>
                      <strong>{{ getPlacement(getActualPlacement(index)) }}</strong>
                    </span>
                    <!-- <span v-else-if="getActualPlacement(index) === 2">
                      <v-icon color="grey darken-1">mdi-trophy</v-icon>
                      <strong>{{ getPlacement(getActualPlacement(index)) }}</strong>
                    </span>
                    <span v-else-if="getActualPlacement(index) === 3">
                      <v-icon color="brown darken-2">mdi-trophy</v-icon>
                      <strong>{{ getPlacement(getActualPlacement(index)) }}</strong>
                    </span> -->
                    <!-- <span v-else>
                      {{ getPlacement(getActualPlacement(index)) }}
                    </span> -->
                  </template>
  
                  <template v-slot:item.createdAt="{ item }">
                    {{ formatExactTime(item.createdAt) }}
                  </template>
  
                  <template v-slot:loading>
                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                  </template>
                </v-data-table>
              </v-card>
            </v-window-item>
          </v-window>
        </v-card-text>
  
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { defineComponent } from 'vue';
import moment from "moment";
import { useTimer } from "vue-timer-hook";

export default defineComponent({
  emits: ["refresh"],
  data() {
    return {
      tab: 0,
      dialog: false,
      title: null,
      sub_title: null,
      action: null,

      snackbar: false,
      snackText: null,

      data: [],
      gtbEntries: [],
      gtbTopWinners: [],
      gthpTopWinners: [],
      slots: [],
      search: null,
      details: [],
      interval: null,
      loading: false,

      viewAllEntriesHeader: [
        { title: "Username", align: 'start', sortable: false, key: 'user.username' },
        { title: "Guess", align: 'start', sortable: false, key: 'guess' },
        { title: 'GTHP Guess', align: 'start', sortable: false, key: 'gthpGuess' },
        { title: "Timestamp", align: 'end', sortable: false, key: 'createdAt' },
      ],

      top10WinnersHeaders: [
        { title: "Placement", align: 'start', sortable: false, key: 'placement' },
        { title: "Username", align: 'start', sortable: false, key: 'user.username' },
        { title: "Guess", align: 'start', sortable: false, key: 'guess' },
        { title: "Difference", align: 'start', sortable: false, key: 'diff' },
        { title: "Timestamp", align: 'end', sortable: false, key: 'createdAt' },
      ],

      top10GTHPWinnersHeaders: [
        { title: "Placement", align: 'start', sortable: false, key: 'placement' },
        { title: "Username", align: 'start', sortable: false, key: 'user.username' },
        { title: "Guess", align: 'start', sortable: false, key: 'gthpGuess' },
        { title: "Difference", align: 'start', sortable: false, key: 'diff' },
        { title: "Timestamp", align: 'end', sortable: false, key: 'createdAt' },
      ],

      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  methods: {
    getAuthHeaders() {
      const token = localStorage.getItem("seham-admin-accesstoken");
      return {
        'Authorization': `Bearer ${token}`,
        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
      };
    },

    async init(data) {
      this.dialog = true;
      this.title = "Guess the Balance";
      this.sub_title = "View the details of the Guess the Balance game";
      this.details = data;

      await this.initData(data);
      this.interval = setInterval(() => this.initData(this.details), 100000);
    },

    async initData(data) {
      this.loading = true;
      try {
        const gtbId = data._id;
        await Promise.all([
          this.loadAllGTBEntries(gtbId),
          this.loadGTBWinners(gtbId)
        ]);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    async loadGTBWinners(gtbId) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_SERVER_URL}/api/admin/guess-the-balance/${gtbId}`,
          { headers: this.getAuthHeaders() }
        );

        if (response.data) {
          const { topWinners, gthpTopWinners, slots } = response.data;
          this.gtbTopWinners = topWinners;
          this.gthpTopWinners = gthpTopWinners;
          this.slots = slots;

          console.log("Checking here")
          console.log(response.data)
        }

      } catch (error) {
        this.handleError(error);
      }
    },

    async loadAllGTBEntries(gtbId) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_SERVER_URL}/api/admin/guess-the-balance/${gtbId}/guesses`,
          { headers: this.getAuthHeaders() }
        );

        if (response.data) {
          this.gtbEntries = response.data.guesses;
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          localStorage.removeItem("vuex");
          localStorage.removeItem("seham-admin-accesstoken");
          window.location.reload();
        } else {
          console.error(`Error: ${error.response.status}`);
        }
      } else if (error.request) {
        console.error('No response received', error.request);
      } else {
        console.error('Error', error.message);
      }
    },

    timer(data) {
      return useTimer(moment(data.timerTimeStarted).utc().add(data.timerDuration, 'minutes'));
    },

    closeDialog() {
      clearInterval(this.interval);
      this.dialog = false;
    },

    getActualPlacement(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },

    getPlacement(index) {
      const suffixes = ["st", "nd", "rd"];
      const defaultSuffix = "th";
      const mod10 = index % 10;
      const mod100 = index % 100;

      if (mod10 >= 1 && mod10 <= 3 && !(mod100 >= 11 && mod100 <= 13)) {
        return `${index}${suffixes[mod10 - 1]}`;
      }
      return `${index}${defaultSuffix}`;
    },

    formatExactTime(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : 'N/A';
    },

    totalNumberOfSlots() {
      return this.slots.length || 0;
    },

    totalNumberOfEntries() {
      return this.gtbEntries.length || 0;
    }
  }
});
</script>

<style scoped>
/* Add your styles here */
</style>
